import {i18n} from '@/plugins/i18n'

export default [
    {
        field: 'id',
        title: 'id',
        sortable: true,
        width: 50,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'customer_detail.fullname',
        title: i18n.t('pos.account_owner_name'),
        sortable: false,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'customer_detail.customer_code',
        title: i18n.t('pos.customer_code'),
        sortable: false,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'sheba_number',
        title: i18n.t('label.sheba_number'),
        sortable: false,
        width: 185,
        textAlign: 'center',
    },
    {
        field: 'sharing_percent',
        title: i18n.t('allotment.percent'),
        sortable: true,
        width: 60,
        textAlign: 'center',
    }
]